import { map } from 'lodash'
import * as shippingService from '../../services/shipping.service'
import {
  CHECK_ZIP_FAIL,
  CHECK_ZIP_SUCCESS,
  GET_ALLOWED_SERVICES_FAIL,
  GET_ALLOWED_SERVICES_SUCCESS,
  SEARCH_TRACKING,
} from './types'
import {mexicoService} from "../../constants/shippingOptions"

export const checkZip =
  ({ zip, country }) =>
  async (dispatch) => {
    try {
      const response = await shippingService.checkZip({
        zip_code: zip,
        country_code: country,
      })
      if (response.status >= 200 && response.status < 300) {
        const { data } = response
        const isValid = data && data.valid
        dispatch({
          type: CHECK_ZIP_SUCCESS,
          zip,
          country,
          isValid,
        })
        return isValid
      }
    } catch (error) {
      const errorData = (error.response && error.response.data) || error.message
      dispatch({ type: CHECK_ZIP_FAIL })
      throw errorData
    }
  }

export const getAllowedShipServices =
  ({ toCode, destZip, origZip }) =>
  async (dispatch) => {
    try {
      if (toCode === "US") {
        const dataParams = {
          from_zip: origZip,
          to_zip: destZip,
          to_country_code: toCode,
        }
        const response = await shippingService.getAllowedServices(dataParams)
        if (response.status >= 200 && response.status < 300) {
          const { data } = response
          dispatch({
            type: GET_ALLOWED_SERVICES_SUCCESS,
            origZip,
            destZip,
            toCode,
            services: map(data.response, (service) => ({
              ...service,
              value: service.name,
            })),
          })
        }
      } else if (toCode === "MX") {
        dispatch({
          type: GET_ALLOWED_SERVICES_SUCCESS,
          origZip,
          destZip,
          toCode,
          services: [mexicoService],
        })
      }
    } catch (error) {
      const errorData = (error.response && error.response.data) || error.message
      dispatch({
        type: GET_ALLOWED_SERVICES_FAIL,
        origZip,
        destZip,
        toCode,
        services: [],
      })
      throw errorData
    }
  }

export const searchTracking = (view, trackingNum) => (dispatch) => {
  dispatch({
    type: SEARCH_TRACKING,
    view,
    trackingNum,
  })
}
